import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { ContactUsService } from '../../core/services/contact-us.service';
import { ContactUs } from '../../core/models/contact-us';
import { Constants } from '../../core/config/Constants';

import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';

@Component({
  selector: 'app-contact-us-form',
  templateUrl: './contact-us-form.component.html',
  styleUrls: ['./contact-us-form.component.css'],
  providers: [ExtraService, UtilityService, ContactUsService]
})
export class ContactUsFormComponent implements OnInit {
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;

  eventID: string;
  message: string;
  contactId: string = null;
  name: string = '';
  contactEmptyId: string = null;
  contactList: Array<ContactUs> = new Array();
  contactDeleteList = new Array<string>();
  contactUs = new ContactUs();

  checkData: boolean = false;

  constructor(private db: AngularFireDatabase, private contactUsService: ContactUsService, private extraService: ExtraService, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, private utilityService: UtilityService, private router: Router) {

  }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      if (params['eventId']) {
        this.eventID = params['eventId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.checkData = true;
        console.log(params['eventId'], this.checkData);
        this.setContactList(params['eventId']);
      }
    });
  }

  setContactList(id) {
    this.message = null;
    var x = this.contactUsService.getContactList(id);
    x.snapshotChanges().subscribe(list => {
      if (this.checkData) {
        this.contactDeleteList = new Array();
        this.contactList = new Array();
        list.forEach(element => {
          var y = element.payload.toJSON() as ContactUs;
          if (element.key) {
            y["$key"] = element.key;
            this.contactList[y.position] = (y as ContactUs);
          }
        });
        console.log(this.contactList, this.checkData);

        this.checkData = false;
      }
    });
  }

  upMenuItem(index) {
    if (index != 0) {
      this.swap(index, index - 1);
    }
  }

  downMenuItem(index) {
    if (index != this.contactList.length - 1) {
      this.swap(index, index + 1);
    }
  }

  swap(index1, index2) {
    let data = this.contactList[index1];
    this.contactList[index1] = this.contactList[index2];
    this.contactList[index2] = data;
  }

  confirmDelete(event: ContactUs) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_CONTACT,
      accept: () => {
        this.deleteEvent(event);
      }
    });
  }

  deleteEvent(event) {
    let index: number = this.contactList.indexOf(event);

    if (index !== -1) {
      this.checkData = false;
      this.contactList.splice(index, 1);
      for (var i = 0; i < this.contactList.length; i++) {
        this.contactList[i].position = i;
      }


      this.db.list(Constants.EVENT_URL + '/' + this.eventID + Constants.CONTACT_US_URL).remove(event.$key).then(res => {
        this.message = "Contact deleted Successfully";
        if (this.contactList && this.contactList.length > 0) {
          let i = 0;
          for (let item of this.contactList) {
            console.log(item.$key, item.position);
            let key = item.$key;
            this.db.object(Constants.EVENT_URL + '/' + this.eventID + Constants.CONTACT_US_URL + "/" + key).update({ position: item.position }).catch(e => { console.log(e) });
            if (i == this.contactList.length - 1) {
              setTimeout(() => {
                this.message = null;
                this.checkData = true;
                this.setContactList(this.eventID);
              }, 1000);
            }
            i++;
          }
        } else {
          setTimeout(() => {
            this.message = null;
            this.checkData = true;
            this.setContactList(this.eventID);
          }, 1000);
        }
      });

    }

  }
  // console.log(this.contactList, '3');
  // this.contactUsService.deleteContact(event.$key, this.eventID, this.contactList).then(res => {
  //   this.message = "Contact deleted Successfully";
  //   setTimeout(() => {
  //     this.message = null;
  //     this.checkData = true;
  //     this.setContactList(this.eventID);
  //   }, 1000);
  // }).catch(error => {
  //   console.log(error.message);
  // });

  // upDateOrder(contactList) {
  //   this.contactUsService.upDateOrder(this.eventID, contactList).then(res => {
  //     console.log(res);
  //     this.message = "Updated Successfully";
  //     setTimeout(() => {
  //       this.message = null;
  //       this.checkData = true;
  //       this.setContactList(this.eventID);
  //     }, 1000);
  //   }).catch(error => {
  //     console.log(error.message);
  //   });
  // }

  submit() {
    for (var i = 0; i < this.contactList.length; i++) {
      this.contactList[i].position = i;
    }
    this.contactUsService.updateContectPosition(this.eventID, this.contactList, this.contactDeleteList);
    this.message = "Contacts ordered Successfully";
    setTimeout(() => {
      this.message = null;
      this.checkData = true;
    }, 1000);
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/contact-us-form/contact-us-form.component.ts